import React, { useState, useEffect } from 'react';
import { FaCalendarWeek, FaArrowRight, FaUser, FaSearch, FaSortAmountUp, FaSortAmountDown, FaEllipsisV, FaInfoCircle, FaEdit, FaTrash, FaVideo, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import { Table, Button, Form, Badge, Dropdown, Modal, Card, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import 'moment/locale/fr';
import Sidebar from '../dashboard/sidebar';
import Navbar from '../dashboard/navbar';
import useAuth from '../dashboard/useAuth';
import { Link } from 'react-router-dom';
import { getAuthToken } from '../../authToken';

const BookingsCoach = () => {
    useAuth();
    const user_id = localStorage.getItem('user_id');

    const [bookings, setBookings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'date_creation', direction: 'descending' });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });
    const [isChargement, setIsChargement] = useState(false);
    const [nbreHeure, setNbreHeure] = useState("");

    const showAlertModal = (message, type = 'primary') => {
        setAlertModal({ message, type });
    };

    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        setAlertModal({ message: '', type: '' });
    };

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Mes Bookings";
            fetchBookingsCoach();
        }
    }, [user_id]);

    const fetchBookingsCoach = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings-coach/${user_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            // const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-bookings-coach/${user_id}/`);

            if (!response.ok) {
                throw new Error('Erreur lors de la récupération des données');
            }

            const data = await response.json();

            if (data.status === 'success') {
                setBookings(data.bookings);
            } else {
                throw new Error(data.message || 'Erreur inconnue');
            }

        } catch (error) {
            console.error('Erreur:', error);
            showAlert(`Erreur de chargement: ${error.message}`, 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // Fonction de tri
    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Filtrer les bookings
    const getFilteredBookings = () => {
        if (!searchTerm) {
            return bookings;
        }

        return bookings.filter(booking =>
            booking.titre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            booking.type_booking?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            booking.lieu?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            booking.description?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    };

    // Appliquer le tri
    const getSortedBookings = () => {
        const filteredBookings = getFilteredBookings();

        return [...filteredBookings].sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    };

    // Pagination
    const indexOfLastBooking = currentPage * itemsPerPage;
    const indexOfFirstBooking = indexOfLastBooking - itemsPerPage;
    const currentBookings = getSortedBookings().slice(indexOfFirstBooking, indexOfLastBooking);
    const totalPages = Math.ceil(getSortedBookings().length / itemsPerPage);

    const handleShowDetailsModal = (booking) => {
        setSelectedBooking(booking);
        setShowDetailsModal(true);
    };

    const handleCloseDetailsModal = () => {
        setShowDetailsModal(false);
        setSelectedBooking(null);
    };




    const [showAssignCoachModal, setShowAssignCoachModal] = useState(false);
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchUserTerm, setSearchUserTerm] = useState('');
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);

    // Fonction pour récupérer la liste des utilisateurs
    const fetchUtilisateurs = async () => {
        setIsLoadingUsers(true);
        try {

            const token = localStorage.getItem('access_token');

            // Envoi au backend
            const response = await fetch(`${process.env.REACT_APP_HOTE}/liste-utilisateurs-complet/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error("Erreur réseau");
            }

            const data = await response.json();
            setUtilisateurs(data);
            setFilteredUsers(data);

        } catch (error) {
            console.error("Error fetching users:", error);
            showAlert("Erreur lors du chargement des utilisateurs", "danger");
        } finally {
            setIsLoadingUsers(false);
        }
    };


    // Fonction pour ouvrir le modal d'assignation
    const handleOpenAssignCoachModal = (booking) => {
        setSelectedBooking(booking);
        setShowAssignCoachModal(true);
        fetchUtilisateurs();
    };

    // Fonction pour fermer le modal
    const handleCloseAssignCoachModal = () => {
        setShowAssignCoachModal(false);
        setSelectedBooking(null);
        setSearchUserTerm('');
    };

    // Fonction pour rechercher des utilisateurs
    const handleSearchUsers = (term) => {
        setSearchUserTerm(term);
        if (!term.trim()) {
            setFilteredUsers(utilisateurs);
            return;
        }

        const filtered = utilisateurs.filter(user =>
            user.nom?.toLowerCase().includes(term.toLowerCase()) ||
            user.prenoms?.toLowerCase().includes(term.toLowerCase()) ||
            user.email?.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredUsers(filtered);
    };

    // Fonction pour assigner un coach
    const [loadingAssignId, setLoadingAssignId] = useState(null);

    // Modifiez la fonction handleAssignCoach pour gérer l'état par utilisateur
    const handleAssignCoach = async (utilisateur) => {
        try {
            setLoadingAssignId(utilisateur.id); // Définir l'ID en cours de chargement
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/assigner-coach-booking/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    booking_id: selectedBooking.id,
                    coach_id: utilisateur.id,
                    user_id: user_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                showAlertModal(data.message || 'Erreur lors de l\'assignation');
            }

            if (data.status === 'success') {
                showAlert(`Coach ${utilisateur.prenoms} ${utilisateur.nom} assigné avec succès`, 'success');
                handleCloseAssignCoachModal();
                fetchBookingsCoach();
            } else {
                showAlertModal(data.message || 'Erreur lors de l\'assignation');
            }

        } catch (error) {
            console.error('Erreur lors de l\'assignation:', error);
            showAlertModal(`Erreur: ${error.message}`, 'danger');
        } finally {
            setLoadingAssignId(null); // Réinitialiser l'ID après le traitement
        }
    };


    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [actionConfirm, setActionConfirm] = useState(null);


    const handleEnregHeure = async (booking) => {
        // Validation basique
        if (!nbreHeure || nbreHeure.trim() === "") {
            showAlertModal("Veuillez saisir le nombre d'heures effectives", "danger");
            return;
        }

        const heuresStr = nbreHeure.replace(',', '.').trim();
        let heuresValue;

        try {
            heuresValue = parseFloat(heuresStr);
        } catch {
            showAlertModal("Format de nombre invalide", "danger");
            return;
        }

        // Contrôle 1: > 0
        if (heuresValue <= 0) {
            showAlertModal("Le nombre d'heures doit être supérieur à 0", "danger");
            return;
        }

        // Contrôle 2: <= 24h
        if (heuresValue > 24) {
            showAlertModal("Le nombre d'heures ne peut pas dépasser 24h", "danger");
            return;
        }

        // Contrôle 3: Calcul des heures prévues
        let heuresPrevues = 0;
        try {
            const [hDebut, mDebut] = booking.heure_deb.split(':').map(Number);
            const [hFin, mFin] = booking.heure_fin.split(':').map(Number);

            const debutMin = hDebut * 60 + (mDebut || 0);
            const finMin = hFin * 60 + (mFin || 0);

            if (finMin > debutMin) {
                heuresPrevues = (finMin - debutMin) / 60;
            }
        } catch (error) {
            console.error("Erreur calcul:", error);
        }

        // Contrôle 4: Ne pas dépasser les heures prévues
        if (heuresPrevues > 0 && heuresValue > heuresPrevues) {
            showAlertModal(`Le nombre d'heures ne peut pas dépasser ${heuresPrevues}h (durée prévue)`, "danger");
            return;
        }

        // Envoi des données
        try {
            setIsChargement(true);
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enreg-nbre-heure/${booking.id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    user_id: user_id,
                    nbreHeure: heuresValue,
                }),
            });

            const data = await response.json();

            if (data.status === 'success') {
                setShowConfirmModal(false);
                showAlert(
                    `${heuresValue}h enregistrées pour "${booking.titre}"`,
                    'success'
                );
                setNbreHeure("");
                fetchBookingsCoach();
            } else {
                showAlertModal(data.message, 'danger');
            }

        } catch (error) {
            console.error('Erreur:', error);
            showAlertModal(`Erreur: ${error.message}`, 'danger');
        } finally {
            setIsChargement(false);
        }
    };


    // Fonction pour calculer les heures du mois
    const calculerHeuresMois = () => {
        const maintenant = moment();
        const debutMois = maintenant.clone().startOf('month');
        const finMois = maintenant.clone().endOf('month');

        let heuresTotales = 0;
        let heuresTerminees = 0;

        bookings.forEach(booking => {
            const dateBooking = moment(booking.date_booking);

            if (dateBooking.isBetween(debutMois, finMois, null, '[]')) {
                const heureDebut = moment(booking.heure_deb, 'HH:mm:ss');
                const heureFin = moment(booking.heure_fin, 'HH:mm:ss');
                const dureeHeures = heureFin.diff(heureDebut, 'hours', true);

                heuresTotales += dureeHeures;

                if (booking.statut === "2") {
                    heuresTerminees += dureeHeures;
                }
            }
        });

        // Enlever .0 pour les nombres entiers
        const heuresTermineesStr = Number.isInteger(heuresTerminees) ? heuresTerminees.toString() : heuresTerminees.toFixed(1);
        const heuresTotalesStr = Number.isInteger(heuresTotales) ? heuresTotales.toString() : heuresTotales.toFixed(1);

        return `${heuresTermineesStr}/${heuresTotalesStr}`;
    };



    // Fonction pour calculer la durée entre deux heures
    const calculerDuree = (heureDebut, heureFin) => {
        try {
            const [heuresDebut, minutesDebut] = heureDebut.split(':').map(Number);
            const [heuresFin, minutesFin] = heureFin.split(':').map(Number);

            const debutEnMinutes = heuresDebut * 60 + minutesDebut;
            const finEnMinutes = heuresFin * 60 + minutesFin;
            const dureeMinutes = finEnMinutes - debutEnMinutes;

            const heures = Math.floor(dureeMinutes / 60);
            const minutes = dureeMinutes % 60;

            // Retourner "8H" ou "8H30" selon s'il y a des minutes
            return minutes > 0 ? `${heures}H${minutes}` : `${heures}H`;
        } catch (error) {
            console.error('Erreur calcul durée:', error);
            return '0H';
        }
    };

    const renderBookingsList = () => {
        const sortedBookings = getSortedBookings();

        return (
            <div className="ibox-content bookings-list-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h4 className="mb-1">Mes Bookings</h4>
                        <p className="text-muted mb-0">
                            {sortedBookings.length} booking{sortedBookings.length >= 2 ? 's' : ''} assigné{sortedBookings.length >= 2 ? 's' : ''}
                        </p>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center gap-2 mr-2">
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto' }}
                                value={itemsPerPage}
                                onChange={(e) => {
                                    setItemsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </Form.Select>
                        </div>

                        <div className="position-relative">
                            <Form.Control
                                type="text"
                                placeholder="Rechercher un booking..."
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setCurrentPage(1);
                                }}
                                style={{ width: '250px' }}
                                size="sm"
                            />
                            <FaSearch
                                className="position-absolute text-muted"
                                style={{ right: '12px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                        </div>
                    </div>
                </div>

                {sortedBookings.length > 0 ? (
                    <div>
                        <div className="">
                            <table className="footable table table-stripped footable-loaded tablet breakpoint">
                                <thead>
                                    <tr>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('titre')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Titre
                                            {sortConfig.key === 'titre' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('type_booking')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Type
                                            {sortConfig.key === 'type_booking' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('date_booking')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Date
                                            {sortConfig.key === 'date_booking' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('heure_deb')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Heure
                                            {sortConfig.key === 'heure_deb' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-center cursor-pointer'
                                            onClick={() => handleSort('heure_deb')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Nbre d'heure
                                            {sortConfig.key === 'heure_deb' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-center cursor-pointer'
                                            onClick={() => handleSort('nbre_heure')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Nbre d'heure effectif
                                            {sortConfig.key === 'nbre_heure' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('type_crenau')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Format
                                            {sortConfig.key === 'type_crenau' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('statut')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Statut
                                            {sortConfig.key === 'statut' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th
                                            className='text-secondary text-wrap cursor-pointer'
                                            onClick={() => handleSort('nombre_reservations')}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Réservations
                                            {sortConfig.key === 'nombre_reservations' && (
                                                sortConfig.direction === 'ascending' ? <FaSortAmountUp className="ms-1" /> : <FaSortAmountDown className="ms-1" />
                                            )}
                                        </th>
                                        <th className='text-secondary text-wrap text-end'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBookings.map((booking) => (
                                        <tr key={booking.id} className="bg-white">
                                            <td>
                                                <div className="fw-bold text-dark">
                                                    {booking.titre.length > 40
                                                        ? `${booking.titre.substring(0, 40)}...`
                                                        : booking.titre
                                                    }
                                                </div>
                                                <div className="text-muted small">
                                                    {booking.description && (
                                                        <span title={booking.description}>
                                                            {booking.description.length > 30
                                                                ? `${booking.description.substring(0, 30)}...`
                                                                : booking.description
                                                            }
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <Badge bg="info" className="fs-6">
                                                    {booking.type_booking}
                                                </Badge>
                                            </td>
                                            <td>
                                                <div className="fw-bold">
                                                    {moment(booking.date_booking).format('DD/MM/YYYY')}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-dark">
                                                    {booking.heure_deb} - {booking.heure_fin}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-center m-0">
                                                    {calculerDuree(booking.heure_deb, booking.heure_fin)}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="text-center m-0">
                                                    {booking.nbre_heure}H
                                                </div>
                                            </td>
                                            <td>
                                                <Badge
                                                    bg={booking.type_crenau === 'en_ligne' ? 'primary' : 'warning'}
                                                    className="fs-6"
                                                >
                                                    {booking.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                                                </Badge>
                                            </td>
                                            <td>
                                                {booking.statut === "1" ? "En attente" : "Terminé"}
                                            </td>
                                            <td>
                                                <span className="badge badge-secondary">
                                                    {booking.nombre_reservations} / {booking.nb_place_total}
                                                </span>
                                            </td>
                                            <td className='text-center'>
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        variant="outline-"
                                                        size="sm"
                                                        id={`dropdown-${booking.id}`}
                                                        className="d-flex align-items-center"
                                                    >
                                                        <FaEllipsisV />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        {/* <Dropdown.Item
                                                            onClick={() => handleShowDetailsModal(booking)}
                                                            className="d-flex align-items-center text-info"
                                                        >
                                                            <FaInfoCircle className="mr-2" />
                                                            Voir détails
                                                        </Dropdown.Item> */}

                                                        {/* NOUVEAU BOUTON - Assigner coach */}
                                                        {/* <Dropdown.Item
                                                            onClick={() => handleOpenAssignCoachModal(booking)}
                                                            className="d-flex align-items-center text-warning"
                                                        >
                                                            <FaUser className="mr-2" />
                                                            Se faire remplacer
                                                        </Dropdown.Item> */}

                                                        <Dropdown.Item
                                                            onClick={() => {
                                                                setSelectedBooking(booking);
                                                                setActionConfirm(() => () => handleEnregHeure(booking));
                                                                setShowConfirmModal(true);
                                                            }}
                                                            className="d-flex align-items-center text-"
                                                        >
                                                            <FaEdit className="mr-2" />
                                                            Déclarer prestation
                                                        </Dropdown.Item>


                                                        {booking.type_crenau === 'en_ligne' && booking.lien_teams && (
                                                            <Dropdown.Item
                                                                href={booking.lien_teams}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="d-flex align-items-center text-success"
                                                            >
                                                                <FaVideo className="mr-2" />
                                                                Rejoindre Teams
                                                            </Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <div className="dataTables_info" role="status" aria-live="polite">
                                    Affichage de {indexOfFirstBooking + 1} à {Math.min(indexOfLastBooking, sortedBookings.length)} sur {sortedBookings.length} booking{sortedBookings.length !== 1 ? 's' : ''}
                                </div>

                                <nav>
                                    <ul className="pagination pagination-sm mb-0">
                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={currentPage === 1}
                                            >
                                                ‹
                                            </button>
                                        </li>

                                        {[...Array(totalPages)].map((_, index) => (
                                            <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}

                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                disabled={currentPage === totalPages}
                                            >
                                                ›
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="text-center py-5">
                        <h5 className="text-muted">
                            {searchTerm ? 'Aucun booking trouvé' : 'Aucun booking assigné'}
                        </h5>
                        <p className="text-muted">
                            {searchTerm
                                ? 'Aucun booking ne correspond à votre recherche.'
                                : 'Aucun booking ne vous est actuellement assigné.'
                            }
                        </p>
                        {/* {searchTerm && (
              <Button
                variant="outline-secondary"
                onClick={() => setSearchTerm('')}
              >
                Effacer la recherche
              </Button>
            )} */}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'>
                                <FaCalendarWeek size={25} className='mr-2' /> Mes Bookings
                            </h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <span>Mes Bookings</span>
                                    </li>
                                </ol>
                            </small>

                            {/* Badge des heures du mois */}
                            <div className="d-flex justify-content-end mt-2">
                                <Badge bg="info" className="fs-6 p-2">
                                    📊 {calculerHeuresMois()}h terminées ce mois
                                </Badge>
                            </div>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`alert alert-${alert.type} row justify-content-between position-relative m-2 mt-2`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                {isLoading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                                        <div className="spiner-example">
                                            <div className="sk-spinner sk-spinner-wave">
                                                <div className="sk-rect1 mr-1"></div>
                                                <div className="sk-rect2 mr-1"></div>
                                                <div className="sk-rect3 mr-1"></div>
                                                <div className="sk-rect4 mr-1"></div>
                                                <div className="sk-rect5"></div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    renderBookingsList()
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de détails du booking */}
                <Modal show={showDetailsModal} onHide={handleCloseDetailsModal} size="md" centered>
                    <Modal.Header className="py-2 px-3 border-bottom">
                        <Modal.Title className="h6 mb-0">Détails du Booking</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-3">
                        {selectedBooking && (
                            <div className="booking-details">
                                {/* Première ligne : Titre et statut */}
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-start">
                                        <div>
                                            <h6 className="mb-0">{selectedBooking.titre}</h6>
                                            <small className="text-muted">
                                                {moment(selectedBooking.date_booking).format('DD/MM/YYYY')} • {selectedBooking.heure_deb}-{selectedBooking.heure_fin}
                                            </small>
                                        </div>
                                        <Badge bg="info">{selectedBooking.type_booking}</Badge>
                                    </div>
                                </div>

                                {/* Deux colonnes côte à côte */}
                                <Row className="mb-3">
                                    <Col md={6} className="border-end">
                                        <div className="pe-3">
                                            <div className="mb-2">
                                                <small className="text-muted d-block">Format</small>
                                                <div>
                                                    <Badge bg={selectedBooking.type_crenau === 'en_ligne' ? 'primary' : 'warning'} className="px-2 py-1">
                                                        {selectedBooking.type_crenau === 'en_ligne' ? 'Virtuel' : 'Présentiel'}
                                                    </Badge>
                                                </div>
                                            </div>

                                            <div className="mb-2">
                                                <small className="text-muted d-block">Places</small>
                                                <div className="fw-bold">{selectedBooking.nombre_reservations}/{selectedBooking.nb_place_total}</div>
                                            </div>

                                            {selectedBooking.type_crenau === 'presentiel' && selectedBooking.lieu && (
                                                <div>
                                                    <small className="text-muted d-block">Lieu</small>
                                                    <div className="small">{selectedBooking.lieu}</div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>

                                    <Col md={6}>
                                        <div className="ps-3">
                                            {selectedBooking.type_crenau === 'en_ligne' && selectedBooking.lien_teams && (
                                                <div className="mb-2">
                                                    <small className="text-muted d-block">Lien de réunion</small>
                                                    <a
                                                        href={selectedBooking.lien_teams}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-primary small"
                                                    >
                                                        Rejoindre la réunion
                                                    </a>
                                                </div>
                                            )}

                                            {selectedBooking.description && (
                                                <div>
                                                    <small className="text-muted d-block">Description</small>
                                                    <div className="small text-truncate-3" style={{ maxHeight: '60px', overflow: 'hidden' }}>
                                                        {selectedBooking.description}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Participants */}
                                {selectedBooking.reservations && selectedBooking.reservations.length > 0 && (
                                    <div className="border-top pt-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <small className="text-muted">Participants ({selectedBooking.reservations.length})</small>
                                        </div>
                                        <div className="border rounded p-2" style={{ maxHeight: '120px', overflowY: 'auto', fontSize: '12px' }}>
                                            {selectedBooking.reservations.map((reservation) => (
                                                <div key={reservation.id} className="d-flex justify-content-between align-items-center mb-1 pb-1 border-bottom">
                                                    <div className="text-truncate" style={{ maxWidth: '60%' }}>
                                                        {reservation.prenom} {reservation.nom}
                                                        <div className="text-muted" style={{ fontSize: '10px' }}>
                                                            {reservation.email}
                                                        </div>
                                                    </div>
                                                    <Badge
                                                        bg={reservation.statut === '2' ? 'success' :
                                                            reservation.statut === '1' ? 'warning' : 'danger'}
                                                        className="px-2 py-1"
                                                        style={{ fontSize: '10px' }}
                                                    >
                                                        {reservation.statut === '1' && 'Attente'}
                                                        {reservation.statut === '2' && 'Confirmé'}
                                                        {reservation.statut === '3' && 'Annulé'}
                                                    </Badge>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="py-2 px-3 border-top">
                        <Button variant="secondary" size="sm" onClick={handleCloseDetailsModal}>
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>



                {/* Modal d'assignation de coach */}
                <Modal show={showAssignCoachModal} onHide={handleCloseAssignCoachModal} size="lg" centered>
                    <Modal.Header className="">
                        <Modal.Title className="d-flex align-items-center">
                            Se faire remplacer - {selectedBooking?.titre}
                        </Modal.Title>
                    </Modal.Header>

                    {alertModal.message && (
                        <div className={`m-3 alert alert-${alertModal.type}`}>
                            {alertModal.message}
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <Modal.Body className="p-4">
                        <div className="mb-4">
                            <Form.Group>
                                <Form.Label>Rechercher un utilisateur</Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        placeholder="Rechercher par nom, prénom ou email..."
                                        value={searchUserTerm}
                                        onChange={(e) => handleSearchUsers(e.target.value)}
                                    />
                                    <FaSearch
                                        className="position-absolute text-muted"
                                        style={{ right: '12px', top: '50%', transform: 'translateY(-50%)' }}
                                    />
                                </div>
                            </Form.Group>
                        </div>

                        {isLoadingUsers ? (
                            <div className="text-center py-4">
                                <div className="spiner-example">
                                    <div className="sk-spinner sk-spinner-wave">
                                        <div className="sk-rect1 mr-1"></div>
                                        <div className="sk-rect2 mr-1"></div>
                                        <div className="sk-rect3 mr-1"></div>
                                        <div className="sk-rect4 mr-1"></div>
                                        <div className="sk-rect5"></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="users-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                {filteredUsers.length > 0 ? (
                                    <table className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nom & Prénom</th>
                                                <th>Email</th>
                                                <th>Téléphone</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredUsers.map((utilisateur) => (
                                                <tr key={utilisateur.id}>
                                                    <td>
                                                        <div className="fw-bold">
                                                            {utilisateur.prenoms} {utilisateur.nom}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <small className="text-muted">{utilisateur.email}</small>
                                                    </td>
                                                    <td>
                                                        <small>{utilisateur.tel || 'Non renseigné'}</small>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            size="sm"
                                                            onClick={() => handleAssignCoach(utilisateur)}
                                                            disabled={loadingAssignId !== null} // Désactiver tous les boutons pendant un chargement OU désactiver seulement celui en cours
                                                            className="btn btn-success d-flex align-items-center justify-content-center mx-auto"
                                                            style={{ minWidth: '100px' }}
                                                        >
                                                            {loadingAssignId === utilisateur.id ? (
                                                                <>
                                                                    <div className="spinner-border spinner-border-sm mr-2" role="status"></div>
                                                                    Assigner
                                                                </>
                                                            ) : (
                                                                <>
                                                                    Assigner
                                                                    <FaArrowRight className="ml-1" />
                                                                </>
                                                            )}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div className="text-center py-4">
                                        <h5 className="text-muted">Aucun utilisateur trouvé</h5>
                                        <p className="text-muted">
                                            {searchUserTerm
                                                ? 'Aucun utilisateur ne correspond à votre recherche.'
                                                : 'Aucun utilisateur disponible.'
                                            }
                                        </p>
                                        {/* {searchUserTerm && (
                              <Button
                                variant="outline-secondary"
                                onClick={() => setSearchUserTerm('')}
                              >
                                <FaTimes className="me-1" />
                                Effacer la recherche
                              </Button>
                            )} */}
                                    </div>
                                )}
                            </div>
                        )}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseAssignCoachModal}>
                            Fermer
                        </Button>
                    </Modal.Footer>
                </Modal>


                {/* Modal de confirmation */}
                {/* Modal de confirmation avec saisie d'heures */}
                <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
                    <Modal.Header>
                        <Modal.Title>Déclarer prestation</Modal.Title>
                    </Modal.Header>
                    {alertModal.message && (
                        <div className={`m-3 alert alert-${alertModal.type}`}>
                            {alertModal.message}
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}
                    <Modal.Body>
                        <div>
                            <div>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        Nombre d'heures effectifs
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="0"
                                        max="24"
                                        step="0.5"
                                        placeholder="Ex: 1.5 pour 1h30"
                                        value={nbreHeure}
                                        onChange={(e) => setNbreHeure(e.target.value)}
                                    />
                                </Form.Group>
                            </div>

                            {/* Information sur la durée prévue */}
                            {selectedBooking && (
                                <div className="mt-2 bg-light rounded">
                                    <small className="text-muted">
                                        Durée prévue : {calculerDuree(selectedBooking.heure_deb, selectedBooking.heure_fin)}
                                        <span className='ml-1'>({selectedBooking.heure_deb} - {selectedBooking.heure_fin})</span>
                                    </small>
                                </div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => {
                                setShowConfirmModal(false);
                                setNbreHeure("");
                                fermerNotif();
                            }}
                            disabled={isChargement}
                        >
                            Annuler
                        </Button>
                        <Button
                            variant="success"
                            onClick={() => handleEnregHeure(selectedBooking)}
                            disabled={isChargement}
                        >
                            {isChargement ? (
                                <>
                                    <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                                    Traitement...
                                </>
                            ) : (
                                "Terminer le booking"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default BookingsCoach;